import React, { useState } from "react"
import { Link } from "react-router-dom"
import { useAuth } from '../AuthContext'

// Terima setShowStats dari props
export const Bighug = ({ setShowStats }) => {
    const { isLoggedIn } = useAuth()
    const [isOpen, setIsOpen] = useState(false)
    const toggleModal = () => setIsOpen(!isOpen)

    const handleScrollToCsr = (e) => {
        e.preventDefault()
        setIsOpen(false)

        // 1. Ubah state jadi true agar komponen CsrCatalog menampilkan section-nya
        setShowStats(true)

        // 2. Beri jeda sedikit (setTimeout) agar React selesai merender elemen sebelum di-scroll
        setTimeout(() => {
            const targetElement = document.getElementById('csr-section')
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                })
            }
        }, 100)
    }

    return (
        <>
            <header className="ms-hero-page-override ms-hero-img-sibeken ms-bg-fixed no-mt pb-4">
                <div className="container">
                    <div className="row no-shadow">
                        <div className="col-lg-12">
                            <div className="row fail">
                                <div className="col-lg-1 col-md-1 col-sm-2"></div>
                                <div className="col-lg-5 col-md-5 col-sm-10 ">
                                    <div className="card card-banner animated zoomInUp animation-delay-3">
                                        <div className="bg-default text-center">
                                            <Link to={isLoggedIn ? '/akun/kegiatan-usaha' : '/login'}>
                                                <img width={200} src="assets/img/bighub.png" alt="" className="icon-layanan" />
                                            </Link>
                                        </div>
                                        <div className="card-body mt-0 text-center">
                                            <h1 className='color-black font-bold lh-125 no-m'>BIG HUB</h1>
                                            <h3 className='color-dark font-bold lh-125 no-m'>Dinas Penanaman Modal dan Pelayanan Terpadu Satu Pintu Kota Bekasi</h3>
                                            <h3 className='text-dark lh-125 no-m'>Bagi pelaku usaha yang ingin mendaftarkan <span className="color-success font-bold">Kegiatan Usaha</span>, <span className="color-success font-bold">Promosi</span> dan kebutuhan terkait <span className="color-success font-bold">Pengadaan</span>. Ataupun bagi pelaku usaha, lembaga dan instansi di Kota Bekasi yang memiliki kendala dan ingin melakukan pertemuan bisnis, kami siap untuk memfasilitasinya melalui fitur <span className="color-success font-bold">Janjian</span>.</h3>
                                            <div className="lh-125">
                                                <Link to={isLoggedIn ? '/akun/kegiatan-usaha' : '/login'} className="btn btn-raised btn-primary br-2">Daftar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-5 col-sm-10 ">
                                    <div className="card card-banner animated zoomInUp animation-delay-3">
                                        <div className="bg-default text-center" style={{ cursor: 'pointer' }} onClick={toggleModal}>
                                            <img height={150} src="assets/img/balaikeren.png" alt="" className="icon-layanan" />
                                        </div>
                                        <div className="card-body mt-0 text-center">
                                            <h1 className='color-black font-bold lh-125 no-m'>SI BALAI KEREN</h1>
                                            <h3 className='color-dark font-bold lh-125 no-m'>Sistem Bantuan Layanan Izin, Investasi dan Kemitraan Rencana Usaha</h3>
                                            <h3 className='text-dark lh-125 no-m'>Bagi pelaku usaha atau investor yang ingin mengembangkan bisnis, seluruh layanan strategis kini terangkum dalam satu pintu. Mulai dari <span className="color-success font-bold">Layanan Jemput Bola Terintegrasi Antar OPD</span>, pemetaan <span className="color-success font-bold">Peta Potensi</span>, pengelolaan <span className="color-success font-bold">CSR</span>, hingga kerja sama via fitur <span className="color-success font-bold">PKS (Perjanjian Kerja Sama)</span> yang cepat dan transparan.</h3>
                                            <div className="lh-125">
                                                <button type="button" className="btn btn-raised btn-primary br-2" onClick={toggleModal}>Daftar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {isOpen && (
                <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content" style={{ borderRadius: '12px', padding: '20px' }}>
                            <div className="modal-header border-0 d-flex justify-content-between align-items-center">
                                <h3 className="modal-title font-bold color-black m-0">PILIH LAYANAN SI BALAI KEREN</h3>
                                <button type="button" className="close" onClick={toggleModal} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer' }}>
                                    <i className="fa fa-times"></i>
                                </button>
                            </div>
                            <div className="modal-body text-center">
                                <p className="text-dark mb-4">Silakan pilih layanan atau fitur strategis di bawah ini:</p>
                                <div style={{ display: 'grid', gap: '10px' }}>
                                    <a href="https://mpp.bekasikota.go.id/jemput-warga" target="_blank" rel="noopener noreferrer" className="btn btn-raised btn-outline-primary btn-block text-left p-3" style={{ textAlign: 'left' }}>
                                        <strong>Layanan Jemput Warga Terintegrasi Antar OPD</strong>
                                    </a>
                                    <a href="http://114.141.49.236/" target="_blank" rel="noopener noreferrer" className="btn btn-raised btn-outline-primary btn-block text-left p-3" style={{ textAlign: 'left' }}>
                                        <strong>Peta Potensi Investasi</strong>
                                    </a>
                                    <a href="#csr-section" onClick={handleScrollToCsr} className="btn btn-raised btn-outline-primary btn-block text-left p-3" style={{ textAlign: 'left' }}>
                                        <strong>Pengelolaan TJSL/CSR</strong>
                                    </a>
                                    <Link to={isLoggedIn ? '/akun/kebutuhan-pengadaan' : '/login'} className="btn btn-raised btn-outline-primary btn-block text-left p-3" style={{ textAlign: 'left' }}>
                                        <strong>Kemitraan Usaha</strong>
                                    </Link>
                                    <a href="https://silat.bekasikota.go.id/register" target="_blank" rel="noopener noreferrer" className="btn btn-raised btn-primary btn-block p-3 mt-2">
                                        Layanan Perizinan Non Berusaha
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}